/**
 * IGNIERE §99: 色/サイズチップ内の在庫サブ行（残りわずか / 欠品中）を JS で挿入。
 *
 * 対象: PDP の .variant-option label（Horizon の variant-main-picker が描画）
 * 判定:
 *   欠品中 : label > input[aria-disabled="true"] （Horizon 標準の DOM）
 *   残りわずか: /products/<handle>.js の variant.inventory_quantity === 1
 * 挿入位置: label 直下に <span class="ig-chip-sub">…</span>
 * 冪等   : data-ig99="applied" マークで多重適用防止。
 *
 * 現状 core (§99) と等価な視覚結果を目指す。CSS は既存 .ig-chip-sub（igniere-brand.liquid）に依存。
 */
(function () {
  'use strict';
  const IG = window.IGNIERE_RUNTIME;
  if (!IG || !IG.register) return;

  // 「残りわずか」用の inventory_quantity==1 マップは
  // sections/igniere-pdp-inventory-data.liquid が Liquid 段で JSON 書き出し。
  // ここでは fetch を使わず、DOM 内の JSON を読むだけ。
  function getInventoryOnesMap() {
    const el = document.getElementById('ig-inventory-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  // Horizon の variant-main-picker は各 input に data-variant-id 属性を出す（core 標準実装）。
  // fetch 不要でここから variant.id を直接取れる。

  function insertSub(label, text) {
    // 既存の ig-chip-sub があれば textContent を上書き
    let sub = label.querySelector('.ig-chip-sub');
    if (!sub) {
      sub = document.createElement('span');
      sub.className = 'ig-chip-sub';
      // core §99 の並び順を再現：<text> の直後・strikethrough より前に挿入。
      // 見つからなければ label 末尾 append にフォールバック。
      const strikethrough = label.querySelector('.variant-option__strikethrough');
      const textEl = label.querySelector('.variant-option__button-label__text');
      if (strikethrough) {
        label.insertBefore(sub, strikethrough);
      } else if (textEl && textEl.nextSibling) {
        label.insertBefore(sub, textEl.nextSibling);
      } else {
        label.appendChild(sub);
      }
    }
    sub.textContent = text;
  }

  function processLabels(labels) {
    const inventoryOnes = getInventoryOnesMap();

    for (const label of labels) {
      if (label.getAttribute('data-ig99') === 'applied') continue;
      const input = label.querySelector('input[type="radio"]');
      if (!input) continue;
      // ①欠品中判定：aria-disabled
      const soldOut = input.getAttribute('aria-disabled') === 'true';
      let text = '';
      if (soldOut) {
        text = '欠品中';
      } else {
        // ②残りわずか判定：input の data-variant-id と inventory_ones テーブル突合
        const variantId = input.getAttribute('data-variant-id');
        if (variantId && inventoryOnes[variantId] === 1) {
          text = '残りわずか';
        }
      }
      if (text) insertSub(label, text);
      label.setAttribute('data-ig99', 'applied');
    }
  }

  IG.register('99-chip-sub', {
    apply(root) {
      if (!root.querySelectorAll) return;
      // core §99 は buttons モード（非 swatch）ラベルにだけ挿入する仕様。
      // swatch モードのラベル（.variant-option__button-label--has-swatch）は除外する。
      const labels = Array.from(
        root.querySelectorAll('.variant-option label:not([data-ig99="applied"])')
      ).filter(
        (l) => !l.classList.contains('variant-option__button-label--has-swatch')
      );
      if (labels.length === 0) return;
      processLabels(labels);
    },
  });
})();
